import { cn } from '../utils/cn';

interface StatusCardProps {
  title: string;
  description?: string;
  priority?: 'high' | 'medium' | 'low' | 'info';
  className?: string;
  onClick?: () => void;
}

const priorityStyles: Record<string, string> = {
  high: 'border-l-danger bg-danger-light',
  medium: 'border-l-warning bg-warning-light',
  low: 'border-l-success bg-success-light',
  info: 'border-l-info bg-info-light',
};

export default function StatusCard({ title, description, priority = 'info', className, onClick }: StatusCardProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'rounded-lg border-l-4 p-3 transition-colors',
        priorityStyles[priority],
        onClick && 'cursor-pointer hover:opacity-80',
        className
      )}
    >
      <p className="text-sm font-medium text-content-primary">{title}</p>
      {description && <p className="text-xs text-content-secondary mt-1">{description}</p>}
    </div>
  );
}
